import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SlideView from "@/views/share/SlideView.vue";
import {useRoute} from "vue-router";
import {Main} from "@/model/main";
import {computed} from "vue";
import {Material} from "@/model/material";
import {MenuItem} from "@/model/materials/tags";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSideView',
  setup(__props) {


const route = useRoute()
const main = route.meta.main as Main
const material = route.meta.material as Material

const menu = computed(() => {
  return material.tags.menus.map((item: MenuItem) => ({key:item.tag,label:material.tags.tags[item.tag].name,children:item.children.map((i:MenuItem) => ({key:i.tag,label:material.tags.tags[i.tag].name,data:i.children}))}))
})

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: _unref(main).active.args.toggle,
    "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((_unref(main).active.args.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_menu, {
        items: menu.value,
        "inline-collapsed": _unref(main).active.args.toggle,
        "open-keys": _unref(main).active.args.openKeys,
        "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_unref(main).active.args.openKeys) = $event)),
        "selected-keys": _unref(main).active.args.path,
        mode: "inline",
        onSelect: _cache[1] || (_cache[1] = ($event: any) => (_unref(main).onMenuChanged($event)))
      }, null, 8, ["items", "inline-collapsed", "open-keys", "selected-keys"])
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})